import { ActionType, createAction } from "typesafe-actions";

import { Company } from "@mapmycustomers/shared/types/entity";

import ApiService from "@app/store/api/ApiService";

// WARNING! Only use this action when you can't get company from the store
export const fetchCompany = createAction("@company/fetchCompany")<{
  callback: (company: Company) => void;
  // False when the caller renders its own inline failure state. Defaults to true so
  // existing call sites keep the global toast they have always had.
  displayNotification?: boolean;
  // Passed the error so a caller can branch on its status — a 404/403 is a permanent
  // "you can't see this record", anything else is worth retrying.
  failureCallback?: (error?: unknown) => void;
  id: Company["id"];
  options?: Parameters<ApiService["fetchCompany"]>[2];
}>();

export const fetchCompanies = createAction("@company/fetchCompanies")<{
  callback: (companies: Company[]) => void;
  failureCallback?: () => void;
  ids: Company["id"][];
}>();

export type Actions = ActionType<typeof fetchCompanies | typeof fetchCompany>;
